import React from "react";

export default () => (
  <svg viewBox="0 0 24 24">
    <path d="M1,1 L22,22 M1,22 L22,1" stroke="#000" strokeWidth="2" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/icons/CloseIconSVG.js